var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticStyle: { "white-space": "nowrap" },
        attrs: {
          headers: _vm.headers,
          items: _vm.values,
          "hide-default-header": _vm.empty,
          height: _vm.values.length > 7 ? 32 * 7 + 32 + 16 : undefined,
          "disable-pagination": "",
          "hide-default-footer": "",
          dense: "",
          "show-select": _vm.bulkMode,
          "item-key": "uid",
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _vm.toolbar
                  ? _c(
                      "v-toolbar",
                      { attrs: { flat: "", dense: "" } },
                      [
                        _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                        _c("v-divider", {
                          staticClass: "mx-2",
                          attrs: { inset: "", vertical: "" },
                        }),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-2",
                            attrs: { small: "", color: "primary" },
                            on: { click: _vm.row_create },
                          },
                          [_vm._v("Add")]
                        ),
                        _c("v-spacer"),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showBulk && _vm.items.length >= 2
                  ? _c(
                      "div",
                      { staticClass: "d-flex pl-4 pb-1 align-center" },
                      [
                        _c("v-checkbox", {
                          staticClass: "mt-0 pt-0",
                          attrs: {
                            "hide-details": "",
                            disabled: !_vm.items.length,
                          },
                          model: {
                            value: _vm.bulkMode,
                            callback: function ($$v) {
                              _vm.bulkMode = $$v
                            },
                            expression: "bulkMode",
                          },
                        }),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-2 white--text",
                            attrs: {
                              "x-small": "",
                              color: "red",
                              disabled:
                                !_vm.bulkMode || !_vm.deletableCountLocal,
                            },
                            on: { click: _vm.bulkRemove },
                          },
                          [
                            _vm._v(" Bulk Delete "),
                            _vm.deletableCountLocal
                              ? _c("span", [
                                  _vm._v(
                                    " (" + _vm._s(_vm.deletableCountLocal) + ")"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "item.actions",
            fn: function ({ item, index }) {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_update(item, index)
                      },
                    },
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_copy(item)
                      },
                    },
                  },
                  [_vm._v("mdi-content-copy")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_moveup(item, index)
                      },
                    },
                  },
                  [_vm._v("mdi-arrow-up-thick")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_movedown(item, index)
                      },
                    },
                  },
                  [_vm._v("mdi-arrow-down-thick")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_remove(item, index)
                      },
                    },
                  },
                  [_vm._v("mdi-delete")]
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("r-reward-package-dropdown-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }